import { z } from 'zod';

import { placeOfResidenceBaseSchema } from '@/features/ui';
import { documentDataSchema } from '@/features/ui/DocumentsData/model/schemas';
import { confirmationOfApplicationSchema } from '@/features/ui/Steps/ConfirmationOfApplication/model/schemas';
import { learningDocumentBaseSchema } from '@/features/ui/Steps/LearningDocument/model/schema';
import { personalAndPassportDataBaseSchema } from '@/features/ui/Steps/PersonalAndPassportData/model/schemas';

import {
  zodArrayOptional,
  zodArrayRequiredWithMinMax,
  zodPlaceholder,
  zodSelectOption,
  zodStringRequired,
  zodWeapon,
} from '@/shared/lib/validations';

import { PurchaseItemIdMapping } from '@/api/types';

export const personStatusBaseSchema = z.object({
  personStatus: zodSelectOption.merge(
    z.object({
      documents: zodArrayRequiredWithMinMax(
        z.object({
          code: zodStringRequired,
          required: z.boolean(),
        }),
        { min: 0 },
      ),
    }),
  ),
  personStatusDocuments: zodArrayOptional(documentDataSchema),
  firearmRegistrationDoc: zodSelectOption.nullish(),
  firearmRegistrationDocument: zodPlaceholder,
});

export const personStatusSchema = personStatusBaseSchema.superRefine((data, ctx) => {
  if (Number(data.firearmRegistrationDoc?.id)) {
    const firearmRegistrationDocumentResult = documentDataSchema.safeParse(data.firearmRegistrationDocument);
    if (!firearmRegistrationDocumentResult.success) {
      ctx.addIssue({
        ...firearmRegistrationDocumentResult.error.issues[0],
        path: ['firearmRegistrationDocument'],
      });
    }
  }
});

export const objectOfPurchaseBaseSchema = z.object({
  objectOfPurchase: zodSelectOption,
  additionalObjectOfPurchase: zodPlaceholder,
  weapon: zodPlaceholder,
  orgNpu: zodSelectOption.extend({ isPayable: z.boolean() }),
  lastStep: zodPlaceholder,
  hasValidPermit: zodPlaceholder,
});

export const objectOfPurchaseSchema = objectOfPurchaseBaseSchema.superRefine((data, ctx) => {
  if (
    data.objectOfPurchase.id === PurchaseItemIdMapping.HUNTING_RIFLED_WEAPONS ||
    data.objectOfPurchase.id === PurchaseItemIdMapping.HUNTING_SMOOTHBORE_WEAPONS
  ) {
    const additionalObjectOfPurchaseResult = zodSelectOption.safeParse(data.additionalObjectOfPurchase);
    if (!additionalObjectOfPurchaseResult.success) {
      ctx.addIssue({
        ...additionalObjectOfPurchaseResult.error.issues[0],
        path: ['additionalObjectOfPurchase'],
      });
    }

    if (data.additionalObjectOfPurchase.id === PurchaseItemIdMapping.WEAPONS_MAIN_PART) {
      const weaponResult = zodWeapon.safeParse(data.weapon);
      if (!weaponResult.success) {
        ctx.addIssue({
          ...weaponResult.error.issues[0],
          path: ['weapon'],
          message: 'Необхідно вибрати зброю',
        });
      }
    }
  }
});

export const weaponPurchasePermitMergedSchema = personStatusBaseSchema
  .merge(personalAndPassportDataBaseSchema)
  .merge(placeOfResidenceBaseSchema)
  .merge(learningDocumentBaseSchema)
  .merge(confirmationOfApplicationSchema)
  .merge(objectOfPurchaseBaseSchema);
